export default {
    contentContainer: {
        alignItems: 'flex-end',
        display: 'flex',
        marginBottom: '5px'
    },
    dropDownMenu: {
        height: '200px',
        overflowY: 'scroll'
    }
};
